import request from '../../../axios';

export const getRecieverData = async (supplierGuid: string) => {
  const {data}: {data: IGetRecieverResponse} = await request.get(
    `/api/profile/supplier-profile/` + supplierGuid,
  );
  return data;
};
